import mitt from 'mitt'
export const useEmitter = mitt()
